import {Radio, RadioGroup} from "rsuite";
import React, {useEffect, useState} from "react";
import {PaymentType} from "../../interfaces/PaymentType";
import {useTranslation} from "react-i18next";

const RadioGroupComponent: React.FC<{
    paymentTypes: PaymentType[],
    value?: number | null,
    onChangePaymentMethod: (value: number) => void }> = (
    {
        paymentTypes,
        value = null,
        onChangePaymentMethod
    }) => {

    const [defaultValue, setDefaultValue] = useState<number | undefined>(value ?? undefined);
    useEffect(() => {
        setDefaultValue(value ?? paymentTypes.find((paymentType) => paymentType.isDefault === true)?.id );
    }, [paymentTypes]);

    const changePaymentValue = (value: number) => {
        setDefaultValue(value);
        onChangePaymentMethod(value)
    }

    return (
        <RadioGroup
            name="radio-group"
            inline
            value={defaultValue}
            onChange={(value, event) => changePaymentValue(value as number)}
        >
            {paymentTypes.map((paymentType) =>
                <Radio key={paymentType.id} value={paymentType.id}>{paymentType.name}</Radio>)}
        </RadioGroup>
    )
}

export default RadioGroupComponent;